import Breadcrumb from 'components/Breadcrumb'
import { BrowserView } from 'components/DeviceDetect'
import Loader from 'components/Loader'
import SectionBlock from 'components/SectionBlock'
import React, { Fragment } from 'react'
import useInnerPage from 'store/InnerPageProvider'
import { TopCategoryContainer, CategoryText } from 'style/Global.style'
import CategoryAllProducts from '../InnerPageProducts'
import InnerPageTiles from './InnerPageTiles'

const InnerPageRightSide = props => {
  const { breadcrumb, tiles, blocks, slug, productResolver } = props
  const { additionalData, category, text } = useInnerPage()

  return (
    <Fragment>
      <TopCategoryContainer>
        <BrowserView>
          <Breadcrumb data={breadcrumb || []} />
        </BrowserView>
      </TopCategoryContainer>
      {additionalData.categoryPageLoading ? (
        <Loader
          visible={true}
          type="Grid"
          css={`
            margin-bottom: 50px;
          `}
          notFull
        />
      ) : null}
      {tiles?.length && <InnerPageTiles tiles={tiles} />}
      {text ? (
        <CategoryText dangerouslySetInnerHTML={{ __html: text }} />
      ) : null}

      <SectionBlock
        key={slug}
        withoutPadding={(blocks || []).length === 0}
        title={category.title}
        titleComponent="h1"
      >
        <CategoryAllProducts
          slug={slug}
          productResolver={productResolver}
          perPage={(blocks || []).length ? 50 : 15}
          category={category}
        />
        <div></div>
      </SectionBlock>
    </Fragment>
  )
}

export default InnerPageRightSide
